<template>
	<!-- 协议弹框 -->
	<common-modal :showClose="true" @close-modal="onCloseModalClick" class="agree-wrap">
	    <div class="modal agree-modal">
			<div class="title agree-title">用心淘下单协议</div>
	        <div class="order-detail">
	            <div class="agree-text">
<!--	               <p>1、处理期间，请拉黑或不与消费者联系、不对评价回复或解释（已回复的不影响处理）；</p>
	               <p>2、处理周期为五天，期限内撤单须扣除该订单付款金额50%违约金，五天期限后可正常申请退款 ；</p>
	               <p>3、五天处理期限内，不自行或交由他人处理，期限内解决的订单，都代表任务完成，应当收取费用 。</p> -->
                <p>1，订单处理期间，为避免双方同时跟进，口吻不一，产生不必要矛盾，延误订单，下单后请不与顾客联系；</p>
                <p>2，订单处理期间，为提高处理效率，打消处理人员顾虑，订单处理期间成功订单都认定为处理人员功劳，请商家勿自行或交由他人处理；</p>
                <p>
                  3，订单周期为5天，据单子难易，时效有长短，确保订单高效、有序处理，处理期间中途撤单，为违约，须承担50% 违约责任。
                </p>
	            </div>
	        </div>
	    </div>
	</common-modal>
</template>

<script>
	import CommonModal from './CommonModal';
    export default {
        data(){
            return{
            }
        },
        methods:{
			onCloseModalClick(){
				this.$emit("close-modal")
			}
            
        },
		components:{
			CommonModal
		}
        
    };
</script>

<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	.agree-wrap{z-index: 15;}
	.agree-wrap .modal-content{position: fixed;bottom: 0;left: 0;right: 0;}
	.agree-wrap .modal-content .close-icon{right: -9.0rem;}
	.agree-wrap .modal-content .modal,.service-wrap .modal-content .modal{padding-bottom:0;}
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.agree-modal{width: 100%;}
	.title{padding: 12px 21px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	.agree-title{padding-left: 25px;padding-right: 22px;text-align: left;font-family:PingFangSC-Semibold,PingFang SC;font-weight:600;color:rgba(20,20,20,1);}
	.agree-text{padding: 20px 25px 30px 25px}
	.agree-text p{font-size:14px;color: rgba(51,51,51,1);line-height:20px;margin-bottom: 18px;letter-spacing: 1.5px;}
	.agree-submit{width:100%;height:48px;line-height: 48px;text-align: center;background:rgba(65,132,244,1);border-radius:1px;font-size:15px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(255,255,255,1);}
</style>
